module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./OfficialInformationView.js"));
	}, "OfficialInformationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OfficialInformationView!./src/pages/Shop/Home/OfficialInformation/OfficialInformationView.js
// module id = 902
// module chunks = 438